import payload_plugin_qLmFnukI99 from "/var/www/website/frontend/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/var/www/website/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/website/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/website/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_jtc2qNDx4l from "/var/www/website/frontend/node_modules/nuxt-site-config/dist/runtime/app/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/var/www/website/frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/website/frontend/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/website/frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/website/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_YksOOA8Nkt from "/var/www/website/frontend/node_modules/nuxt-snackbar/dist/runtime/plugin.js";
import plugin_vue3_YdLad5Mpq3 from "/var/www/website/frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/var/www/website/frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/website/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_Ug908EZNww from "/var/www/website/frontend/node_modules/nuxt-site-config/dist/runtime/app/plugins/i18n.js";
import plugin_client_UYiXMU8ZyN from "/var/www/website/frontend/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/var/www/website/frontend/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/var/www/website/frontend/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import fontawesome_a3gDgrBaWH from "/var/www/website/frontend/node_modules/@vesp/nuxt-fontawesome/dist/runtime/plugins/fontawesome.mjs";
import api_QQzOodE9HA from "/var/www/website/frontend/plugins/api.js";
import cookies_client_8aYpFLR3e9 from "/var/www/website/frontend/plugins/cookies.client.js";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_jtc2qNDx4l,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_YksOOA8Nkt,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_Ug908EZNww,
  plugin_client_UYiXMU8ZyN,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  fontawesome_a3gDgrBaWH,
  api_QQzOodE9HA,
  cookies_client_8aYpFLR3e9
]